export const selectConnector = (state) => state.chargingPoint?.connectorData;
export const selectIsButtonLoading = (state) => state.chargingPoint?.isButtonLoading;
